import * as EXPLORER_ACTION from 'js/constant/action/explorer'
import * as AUTH_ACTION from 'js/constant/action/auth'
import { createAction } from 'redux-actions'
import { divideArrayIntoGroups, getRandomInt } from 'js/helper/action/explorer'
import { getLastSession, getSearchByValue, saveLastSession, getExplorerBuilder, getNetworkState, getCustomerEdge, getRetailers, getCustomerByValue, getContactsById, getRefundsById, getContactsByValue, getCustomerById, getCustomerByName } from 'js/redux/api/explorer'
import _ from 'lodash'
import { CURRENCY_FORMATTER } from 'js/helper/currency'
import pluralize from 'pluralize'
import { encryptUrlParams } from '../helper/action/explorer'
import { Auth } from 'aws-amplify'

const updateLoader = createAction(EXPLORER_ACTION.UPDATE_EXPLORER_LOADER)
const updateOutput = createAction(EXPLORER_ACTION.UPDATE_OUTPUT)
const updateContacts = createAction(EXPLORER_ACTION.UPDATE_ALL_CONTACTS)
const updateAllNodes = createAction(EXPLORER_ACTION.UPDATE_ALL_NODES)
const updateAllEdges = createAction(EXPLORER_ACTION.UPDATE_ALL_EDGES)
const updateNetwork = createAction(EXPLORER_ACTION.UPDATE_NETWORK)
const updateNetworkViewParams = createAction(EXPLORER_ACTION.UPDATE_NETWORK_VIEW_PARAMS)
const updateCustomerModal = createAction(EXPLORER_ACTION.UPDATE_CUSTOMER_MODAL)
const updateProductModal = createAction(EXPLORER_ACTION.UPDATE_PRODUCT_MODAL)
const updateCustomerData = createAction(EXPLORER_ACTION.UPDATE_CUSTOMER_DATA)
const updateCustomerEdges = createAction(EXPLORER_ACTION.UPDATE_CUSTOMER_EDGES)
const updateProductData = createAction(EXPLORER_ACTION.UPDATE_PRODUCT_DATA)
const updateNetworkBreadcrumbData = createAction(EXPLORER_ACTION.UPDATE_NETWORK_BREADCRUMB_DATA)
const updateExplorerFilterData = createAction(EXPLORER_ACTION.UPDATE_EXPLORER_FILTER_DATA)
const updateNetworkFilter = createAction(EXPLORER_ACTION.UPDATE_NETWORK_FILTER)
const updateMetadataData = createAction(EXPLORER_ACTION.UPDATE_METADATA_DATA)
const updateMetadataModal = createAction(EXPLORER_ACTION.UPDATE_METADATA_OPEN)
const updateResultMessage = createAction(EXPLORER_ACTION.UPDATE_RESULT_MESSAGE)
const updateResultModal = createAction(EXPLORER_ACTION.UPDATE_RESULT_MODAL)
const updateExplorerPagination = createAction(EXPLORER_ACTION.UPDATE_EXPLORER_PAGINATION)
const updateNodesInfo = createAction(EXPLORER_ACTION.UPDATE_NODES_INFO)
const updateEdgesInfo = createAction(EXPLORER_ACTION.UPDATE_EDGES_INFO)
const expandCustomerNodes = createAction(EXPLORER_ACTION.EXPAND_CUSTOMER_NODES)
const listCustomerDetails = createAction(EXPLORER_ACTION.LIST_CUSTOMER_DETAILS)
const expandContactNodes = createAction(EXPLORER_ACTION.EXPAND_CONTACT_NODES)
const listContactDetails = createAction(EXPLORER_ACTION.LIST_CONTACT_DETAILS)
const disconnectNodes = createAction(EXPLORER_ACTION.DISCONNECT_NODES)
const expandRecursively = createAction(EXPLORER_ACTION.EXPAND_RECURSIVELY)
const updateTotalNetworkValue = createAction(EXPLORER_ACTION.UPDATE_TOTAL_NETWORK_VALUE)
const updateRetailers = createAction(EXPLORER_ACTION.UPDATE_RETAILERS)

const updateIsAuthenticated = createAction(AUTH_ACTION.UPDATE_IS_AUTHENTICATED)
const updateUser = createAction(AUTH_ACTION.UPDATE_USER_DETAILS)

export const setNodesInfo = (nodes) => async (dispatch, getState) => {
  dispatch(updateNodesInfo(nodes))
}

export const setEdgesInfo = (data) => async (dispatch, getState) => {
  dispatch(updateEdgesInfo(data))
}

export const setAllNodes = (nodes) => async (dispatch, getState) => {
  dispatch(updateAllNodes(nodes))
}

export const setAllEdges = (data) => async (dispatch, getState) => {
  dispatch(updateAllEdges(data))
}

export const openProductModal = (bool) => async (dispatch, getState) => {
  dispatch(updateProductModal(bool))
}

export const setErrorMessage = (message, bool) => async (dispatch, getState) => {
  await dispatch(updateResultMessage(message))
  dispatch(updateResultModal(bool))
}

export const setErrorModal = (bool) => async (dispatch, getState) => {
  dispatch(updateResultModal(bool))
}

export const setBreadcrumbsData = (item) => async (dispatch, getState) => {
  dispatch(updateNetworkBreadcrumbData(item))
}

export const showNetworkFilter = (bool) => async (dispatch, getState) => {
  dispatch(updateNetworkFilter(bool))
}

export const setCriteria = (item) => async (dispatch, getState) => {
  dispatch(updateExplorerFilterData(item))
}

export const openCustomerModal = (bool) => async (dispatch, getState) => {
  dispatch(updateCustomerModal(bool))
}

export const setCustomerData = (data) => async (dispatch, getState) => {
  dispatch(updateCustomerData(data))
}

export const openMetadataModal = (bool) => async (dispatch, getState) => {
  dispatch(updateMetadataModal(bool))
}

export const setMetadataData = (data) => async (dispatch, getState) => {
  dispatch(updateMetadataData(data))
}

export const setProductData = (data) => async (dispatch, getState) => {
  dispatch(updateProductData(data))
}

export const setExplorerPagination = (data) => async (dispatch, getState) => {
  dispatch(updateExplorerPagination(data))
}

export const setNetwork = (network) => (dispatch) => {
  dispatch(updateNetwork(network))
}

export const setNodes = (nodes) => (dispatch) => {
  dispatch(updateAllNodes(nodes))
}

export const setEdges = (edges) => (dispatch) => {
  dispatch(updateAllEdges(edges))
}

export const removeNodes = (nodes, ids) => async (dispatch, getState, { explorer }) => {
  try {
    const newList = nodes.filter(item => !ids.includes(item.id))
    dispatch(updateNodesInfo(newList))
  } catch (error) {
    dispatch(updateLoader(false))
    console.error(error)
  }
}

export const removeEdges = (edges, ids) => async (dispatch, getState, { explorer }) => {
  try {
    const newList = edges.filter(item => !ids.includes(item.id))
    dispatch(updateEdgesInfo(newList))
  } catch (error) {
    dispatch(updateLoader(false))
    console.error(error)
  }
}

export const getContactById =
  (id) =>
    async (dispatch, getState, { explorer }) => {
      try {
        dispatch(updateLoader(true))
        const result = await getContactsById(id)

        if (result.nodes) {
          const nodes = result.nodes.map(item => 
            ({ ...item, 
              retailer: item.retailer && _.capitalize(item.retailer), 
              group: item.retailer_count > 1 ? 'contact_2' : 'contact_1', 
              label: `${item.code.length > 15 ? `${item.code.slice(0, 9)}...` : item.code}: (${item.number_of_refunds}) \n${CURRENCY_FORMATTER.format(item.refund_value)}` 
            }))
          dispatch(updateNodesInfo(nodes))
          dispatch(updateLoader(false))
          return nodes
        }
      } catch (error) {
        dispatch(updateLoader(false))
        console.error(error)
      }
    }

export const getExplorerBuilderQuery =
  (data) =>
    async (dispatch, getState, { explorer }) => {
      try {
        dispatch(updateLoader(true))
        const ids = await getExplorerBuilder(data)

        if (_.isEmpty(ids) || _.isEmpty(ids.nodes)) {
          setErrorMessage([], true)
          dispatch(updateLoader(false))
          return []
        } else if (ids && ids.nodes.length > 100) {
          const divided = await divideArrayIntoGroups(ids.nodes, 100)
          const result = await getContactsById(divided[0])

          const nodes = await result.nodes.map(item => 
            ({ ...item, 
              retailer: item.retailer && _.capitalize(item.retailer), 
              group: item.retailer_count > 1 ? 'contact_2' : 'contact_1', 
              label: `${item.code.length > 15 ? `${item.code.slice(0, 9)}...` : item.code}: (${item.number_of_refunds}) \n${CURRENCY_FORMATTER.format(item.refund_value)}` 
            }))

          await dispatch(updateExplorerPagination(divided))
          dispatch(updateAllNodes(nodes))
          dispatch(updateLoader(false))
          return nodes
        } else {
          const result = await getContactsById(ids.nodes)
          const nodes = await result.nodes.map(item => 
            ({ ...item, 
              retailer: item.retailer && _.capitalize(item.retailer), 
              group: item.retailer_count > 1 ? 'contact_2' : 'contact_1', 
              label: `${item.code.length > 15 ? `${item.code.slice(0, 9)}...` : item.code}: (${item.number_of_refunds}) \n${CURRENCY_FORMATTER.format(item.refund_value)}` 
            }))
          dispatch(updateAllNodes(nodes))
          dispatch(updateLoader(false))
          return nodes
        }
      } catch (error) {
        dispatch(updateLoader(false))
        console.error(error)
      }
    }

export const getContactBySearch =
  (contact) =>
    async (dispatch, getState, { explorer }) => {
      try {
        dispatch(updateLoader(true))
        const result = await getContactsByValue(_.trim(_.toUpper(contact)))

        if (!_.isEmpty(result.nodes)) {
          const nodes = result.nodes.map(item => 
            ({ ...item, 
              retailer: item.retailer && _.capitalize(item.retailer), 
              group: item.retailer_count > 1 ? 'contact_2' : 'contact_1', 
              label: `${item.code.length > 15 ? `${item.code.slice(0, 9)}...` : item.code}: (${item.number_of_refunds}) \n${CURRENCY_FORMATTER.format(item.refund_value)}` 
            }))
          dispatch(updateAllNodes(nodes))
          dispatch(updateLoader(false))
          return nodes
        } else {
          dispatch(updateLoader(false))
          return false
        }
      } catch (error) {
        dispatch(updateLoader(false))
        console.error(error)
      }
    }

export const getItemBySearch =
  (contact) =>
    async (dispatch, getState, { explorer }) => {
      try {
        dispatch(updateLoader(true))
        const result = await getSearchByValue(_.trim(_.toUpper(contact)))
        const customerResult = _.isArray(contact) ? await getCustomerByName(contact.map(item => _.trim(item))) : await getCustomerByName([_.trim(contact)])
        const nodes = []

        if (_.isEmpty(result.nodes) && _.isEmpty(customerResult.nodes)) {
          dispatch(updateLoader(false))
          return false
        } else {
          !_.isEmpty(result.nodes) && await nodes.push(...result.nodes.map(item => 
            ({ ...item, 
              retailer: item.retailer && _.capitalize(item.retailer), 
              group: item.retailer_count > 1 ? 'contact_2' : 'contact_1', 
              label: `${item.code.length > 15 ? `${item.code.slice(0, 9)}...` : item.code}: (${item.number_of_refunds}) \n${CURRENCY_FORMATTER.format(item.refund_value)}` 
            })))

          !_.isEmpty(customerResult.nodes) && await nodes.push(...customerResult.nodes.map(item => 
            ({ ...item, 
              retailer: item.retailer && _.capitalize(item.retailer), 
              group: item.contact_count > 1 ? `${item.retailer}_2` : `${item.retailer}_1`, 
              label: `${item.number_of_refunds} ${pluralize('Claim', item.number_of_refunds)}: \n${CURRENCY_FORMATTER.format(item.refund_value)}` 
            })))
          dispatch(updateAllNodes(nodes))
          dispatch(updateLoader(false))
          return nodes
        }
      } catch (error) {
        dispatch(updateLoader(false))
        console.error(error)
      }
    }

export const getCustomerEdges =
  (id, contact) =>
    async (dispatch, getState, { explorer }) => {
      try {
        const result = await getCustomerEdge(id, contact)

        if (result && !_.isEmpty(result.edge)) {
          const newEdges = result.edge.map(item => ({ ...item, label: item.label.toString(), length: getRandomInt(300, 600) }))
          dispatch(updateLoader(false))
          return newEdges
        }
      } catch (error) {
        dispatch(updateLoader(false))
        console.error(error)
      }
    }

export const getCustomer =
  (id, selectedContact, showModal) =>
    async (dispatch, getState, { explorer }) => {
      try {
        const result = await getCustomerById(id)
        if (showModal) {
          const nodes = result.nodes.map(item => 
            ({ ...item, 
              contact: selectedContact, 
              retailer: item.retailer && _.capitalize(item.retailer), 
              group: item.contact_count > 1 ? `${item.retailer}_2` : `${item.retailer}_1`, 
              label: `${item.number_of_refunds} ${pluralize('Claim', item.number_of_refunds)}: \n${CURRENCY_FORMATTER.format(item.refund_value)}` 
            }))
          dispatch(updateMetadataModal(false))
          dispatch(updateCustomerData(nodes))
          dispatch(updateCustomerModal(true))
          dispatch(updateCustomerEdges(result.edges))
        } else {
          const nodes = result.nodes.map(item => 
            ({ ...item, 
              retailer: item.retailer && _.capitalize(item.retailer), 
              group: item.contact_count > 1 ? `${item.retailer}_2` : `${item.retailer}_1`, 
              label: `${item.number_of_refunds} ${pluralize('Claim', item.number_of_refunds)}: \n${CURRENCY_FORMATTER.format(item.refund_value)}` 
            }))
          dispatch(updateLoader(false))
          return { nodes, edges: result.edges }
        }
      } catch (error) {
        dispatch(updateLoader(false))
        console.error(error)
      }
    }

export const getCustomerByCustomerId =
      (customerId) =>
        async (dispatch, getState, { explorer }) => {
          try {
            dispatch(updateLoader(true))
            const result = await getCustomerByValue(customerId)
            if (result) {
              const nodes = await result.nodes.map(item => {
                if (item.customer_id) {
                  return { 
                    ...item, 
                    retailer: item.retailer && _.capitalize(item.retailer), 
                    group: item.contact_count > 1 ? `${item.retailer}_2` : `${item.retailer}_1`, 
                    label: `${item.number_of_refunds} ${pluralize('Claim', item.number_of_refunds)}: \n${CURRENCY_FORMATTER.format(item.refund_value)}` 
                  }
                } else {
                  return { 
                    ...item, 
                    group: item.retailer_count > 1 ? 'contact_2' : 'contact_1', 
                    label: `${item.code.length > 15 ? `${item.code.slice(0, 9)}...` : item.code}: (${item.number_of_refunds}) \n${CURRENCY_FORMATTER.format(item.refund_value)}` 
                  }
                }
              })
              dispatch(updateLoader(false))
              return { nodes, edges: result.edges }
            } else {
              dispatch(updateLoader(false))
              return false
            }
          } catch (error) {
            dispatch(updateLoader(false))
            console.error(error)
          }
        }

export const getCustomerContacts =
  (id, contacts) =>
    async (dispatch, getState, { explorer }) => {
      try {
        const result = await getContactsByValue(contacts)
        const edges = await getCustomerEdge(id, contacts)

        if (result && !_.isEmpty(result.nodes)) {
          const nodes = result.nodes.map(item => 
            ({ ...item, 
              retailer: item.retailer && _.capitalize(item.retailer), 
              group: item.retailer_count > 1 ? 'contact_2' : 'contact_1', 
              label: `${item.code.length > 15 ? `${item.code.slice(0, 9)}...` : item.code}: (${item.number_of_refunds}) \n${CURRENCY_FORMATTER.format(item.refund_value)}` 
            }))
          const newEdges = edges.edge.map(item => 
            ({ ...item, 
              label: item.label.toString(), 
              length: getRandomInt(300, 600) 
            }))
          return { nodes, edges: newEdges }
        } else {
          dispatch(updateLoader(false))
          return false
        }
      } catch (error) {
        dispatch(updateLoader(false))
        console.error(error)
      }
    }


export const getRefunds =
  (id, nodes) =>
    async (dispatch, getState, { explorer }) => {
      try {
        const result = await getRefundsById(id)

        const customer = nodes.filter(item => item.id === id)

        if (result.nodes) {
          dispatch(updateProductData({ customer, refund: result.nodes }))
          dispatch(updateMetadataModal(false))
          dispatch(updateProductModal(true))
          dispatch(updateLoader(false))
        }
      } catch (error) {
        dispatch(updateLoader(false))
        console.error(error)
      }
    }

export const resetState =
  () =>
    (dispatch, getState, { explorer }) => {
      dispatch(updateOutput(null))
      dispatch(updateContacts([]))
      dispatch(updateUser(null))
      dispatch(updateIsAuthenticated(false))
    }

export const setNetworkViewParams =
    (networkData) =>
      async (dispatch, getState, { explorer }) => {
        dispatch(updateNetworkViewParams(networkData))
      }

export const getLastSessionUrl =
  () =>
    async (dispatch, getState, { explorer }) => {
      try {
        const {
          auth: { userDetails }
        } = await getState()

        var credentials = await Auth.currentCredentials();
        const response = await getLastSession(credentials.identityId)
        if (response[0]) {
          dispatch(updateLoader(false))
          return response[0].url
        }
      } catch (error) {
        dispatch(updateLoader(false))
        console.error(error)
      }
    }

export const getAllRetailers = 
    () =>
      async (dispatch, getState, { explorer }) => {
        try {
          const result = await getRetailers();

          let retailers = result.retailers;
          if(result.retailers.length > 1) {
            retailers = ['All Results', ...retailers, 'Multiple Retailers']
          }

          dispatch(updateRetailers(retailers));
        } catch (error) {
          dispatch(updateLoader(false))
          console.log(error);
        }
      }



export const getUrlParams =
  (data) =>
    async (dispatch, getState, { explorer }) => {
      try {
        dispatch(updateLoader(true))

        const linkedData = data.unlinked ? _.omit(data, ['unlinked']) : data
        const result = await getNetworkState(linkedData)
        if (result) {
          const nodes = result.nodes.map(item => {
            if (item.customer_id) {
              return { 
                ...item, 
                retailer: item.retailer && _.capitalize(item.retailer), 
                group: item.contact_count > 1 ? `${item.retailer.toLowerCase()}_2` : `${item.retailer.toLowerCase()}_1`, 
                label: `${item.number_of_refunds} ${pluralize('Claim', item.number_of_refunds)}: \n${CURRENCY_FORMATTER.format(item.refund_value)}` 
              }
            } else {
              return { 
                ...item, 
                group: item.retailer_count > 1 ? 'contact_2' : 'contact_1', 
                label: `${item.code.length > 15 ? `${item.code.slice(0, 9)}...` : item.code}: (${item.number_of_refunds}) \n${CURRENCY_FORMATTER.format(item.refund_value)}` 
              }
            }
          })

          // Remove duplicate edges, and then add a new randomised `length` value to each unique edge. 
          const newEdges = _.uniqWith(result.edges, (edge1, edge2) => edge1.to === edge2.to && edge1.from === edge2.from).map(item => ({ ...item, length: getRandomInt(300, 600) }))

          if (data.unlinked && !_.isEmpty(data.unlinked)) {
            const customers = await getCustomerByValue(data.unlinked)
            const customerOnly = customers.nodes.filter(item => item.customer_id)
            const unlinkedNodes = customerOnly.map(item => ({ 
              ...item, 
              retailer: item.retailer && _.capitalize(item.retailer), 
              group: item.contact_count > 1 ? `${item.retailer}_2` : `${item.retailer}_1`, label: `${item.number_of_refunds} ${pluralize('Claim', item.number_of_refunds)}: \n${CURRENCY_FORMATTER.format(item.refund_value)}` 
            }))
            await dispatch(updateAllNodes(_.uniqBy([..._.uniqBy(nodes, 'id'), ...unlinkedNodes], 'id')))
            await dispatch(updateAllEdges(newEdges))
            dispatch(updateLoader(false))
            return { nodes: _.uniqBy([..._.uniqBy(nodes, 'id'), ...unlinkedNodes], 'id'), edges: newEdges }
          } else {
            await dispatch(updateAllNodes(_.uniqBy(nodes, 'id')))
            await dispatch(updateAllEdges(newEdges))
            dispatch(updateLoader(false))
            return { nodes: _.uniqBy(nodes, 'id'), edges: newEdges }
          }
        }
      } catch (error) {
        dispatch(updateLoader(false))
        console.error(error)
      }
    }

export const saveLastSessionUrl =
  (urlParams) =>
    async (dispatch, getState, { explorer }) => {
      const encryptedString = encryptUrlParams(urlParams)
      try {
        const {
          auth: { userDetails }
        } = await getState()

        var credentials = await Auth.currentCredentials();

        const response = await saveLastSession(credentials.identityId, encryptedString)
        setNetworkViewParams(encryptedString)
        return response
      } catch (error) {
        dispatch(updateLoader(false))
        console.error(error)
      }
    }

export const setMetadataOpen =
  (bool) =>
    (dispatch, getState, { explorer }) => {
      dispatch(updateMetadataModal(bool))
    }

export const setExpandCustomerNodes = () => (dispatch) => {
  dispatch(expandCustomerNodes())
}

export const setListCustomerDetails = () => (dispatch) => {
  dispatch(listCustomerDetails())
}

export const setExpandContactNodes = () => (dispatch) => {
  dispatch(expandContactNodes())
}

export const setListContactDetails = () => (dispatch) => {
  dispatch(listContactDetails())
}

export const setDisconnectNodes = () => (dispatch) => {
  dispatch(disconnectNodes())
}

export const setExpandRecursively = () => (dispatch) => {
  dispatch(expandRecursively())
}

export const setTotalNetworkValue = (data) => async (dispatch, getState) => {
  dispatch(updateTotalNetworkValue(data))
}